var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-btn",
        {
          directives: [
            {
              name: "clipboard",
              rawName: "v-clipboard:copy",
              value: _vm.text,
              expression: "text",
              arg: "copy"
            },
            {
              name: "clipboard",
              rawName: "v-clipboard:success",
              value: _vm.handleClipboardSuccess,
              expression: "handleClipboardSuccess",
              arg: "success"
            },
            {
              name: "clipboard",
              rawName: "v-clipboard:error",
              value: _vm.handleClipboardError,
              expression: "handleClipboardError",
              arg: "error"
            }
          ],
          attrs: { icon: "content_copy", small: "", flat: "", color: "primary" }
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("copy")) + "\n  ")]
      ),
      _c(
        "div",
        [
          _c(
            "q-tooltip",
            {
              attrs: {
                anchor: "top middle",
                self: "bottom middle",
                offset: [0, 30]
              },
              model: {
                value: _vm.showTooltip,
                callback: function($$v) {
                  _vm.showTooltip = $$v
                },
                expression: "showTooltip"
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("copied")) + "\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }